export function incidentRecordingsRoute(incidentId: string): string {
  return `/incident/${incidentId}/recordings`;
}

export function incidentRecordingDetailRoute(incidentId: string, videoId: string): string {
  return `/incident/${incidentId}/recordings/${videoId}`;
}
